import { logger } from '../../utils/logger';
export enum STAGES {
  INT = 'int',
  DEV = 'dev',
  TEST = 'test',
  PROD = 'prod',
  PPROD = 'pprod',
}
export type Stage = STAGES.DEV | STAGES.TEST | STAGES.INT | STAGES.PPROD | STAGES.PROD;
export class Environment {
  private _stage!: Stage;
  private fssCoreUrls: Record<Stage, string> = {
    [STAGES.TEST]: 'https://test.api.oneweb.mercedes-benz.com/fss-core/v1',
    [STAGES.PROD]: 'https://api.oneweb.mercedes-benz.com/fss-core/v1',
    [STAGES.INT]: 'https://int.api.oneweb.mercedes-benz.com/fss-core/v1',
    [STAGES.PPROD]: 'https://int.api.oneweb.mercedes-benz.com/fss-core/v1',
    [STAGES.DEV]: 'https://test.api.oneweb.mercedes-benz.com/fss-core/v1/',
  };
  constructor() {
    this._stage = STAGES.DEV;
  }
  private isStageValid(stage: Stage): boolean {
    return !!this.fssCoreUrls[stage];
  }
  set stage(value: Stage) {
    const isValid = this.isStageValid(value);
    logger.log(isValid ? `Setting the stage from AEM: ${value}` : `Stage is ${value}, using default: ${STAGES.DEV}`);
    this._stage = isValid ? value : STAGES.DEV;
  }
  get fssCoreApiUrl(): string {
    return this.fssCoreUrls[this._stage];
  }
}
export const environment = new Environment();
